import React from 'react';
import '../../styles/ContactPreview.css';

const ContactPreview = () => {
  // Phone number for calls
  const phoneNumber = '+918019472678';
  // WhatsApp number (without + for URL)
  const whatsappNumber = '918019472678';
  // Pre-filled message for WhatsApp
  const whatsappMessage = 'Hi! I want to book a room at AA GRAND HOTEL';

  return (
    <section className="contact-preview-section" id="contact">
      <div className="contact-preview-container">
        {/* Section Header */}
        <div className="contact-preview-header">
          <span className="contact-preview-badge">✦ Get In Touch</span>
          <h2 className="contact-preview-title">
            Ready to <span className="highlight">Book Your Stay?</span>
          </h2>
          <p className="contact-preview-subtitle">
            Call us or WhatsApp for instant booking confirmation and best deals!
          </p>
        </div>

        {/* Contact Cards */}
        <div className="contact-preview-grid">
          {/* Call Card */}
          <div className="contact-card call-card">
            <div className="contact-card-icon">📞</div>
            <h3>Call Now</h3>
            <p>For instant booking and inquiries</p>
            <a href={`tel:${phoneNumber}`} className="contact-btn call-btn">
              Call Now →
            </a>
          </div>

          {/* WhatsApp Card */}
          <div className="contact-card whatsapp-card">
            <div className="contact-card-icon">💬</div>
            <h3>WhatsApp</h3>
            <p>Chat with us for quick responses</p>
            <a 
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-btn whatsapp-btn"
            >
              WhatsApp Now →
            </a>
          </div>

          {/* Location Card */}
          <div className="contact-card location-card">
            <div className="contact-card-icon">📍</div>
            <h3>Visit Us</h3>
            <p>Ameerpet Metro Pillar No. 1072,<br />Above Bata Showroom, First Floor,<br />Hyderabad, Telangana</p>
            <a 
              href="https://maps.google.com/maps?q=Ameerpet+Metro+Pillar+No+1072+Hyderabad" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-btn location-btn"
            >
              Get Directions →
            </a>
          </div>
        </div>

        {/* Quick Info */}
        <div className="contact-preview-info">
          <div className="info-item">
            <span className="info-icon">🕐</span>
            <div>
              <h4>Check-in / Check-out</h4>
              <p>12:00 PM / 11:00 AM</p>
            </div>
          </div>
          <div className="info-item">
            <span className="info-icon">📧</span>
            <div>
              <h4>Email</h4>
              <p>info@hotelsinhyderabad.com</p>
            </div>
          </div>
          <div className="info-item">
            <span className="info-icon">🏨</span>
            <div>
              <h4>Hotel Name</h4>
              <p>AA GRAND HOTEL</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPreview;